export const Breakpoints = {
  Desktop: '768px',
  Mobile: '480px'
};

/** ------------- COLORS -------------- */

/* Primary */
export const $Midnight = '#0C204E';
export const $BitPay = '#1A3B8B';
export const $Action = '#4F6EF7';

/* Secondary */
export const $SlateDark = '#434D5A';
export const $Slate = '#9BA3AE';
export const $Slate10 = '#f5f7f8';
export const $Slate30 = '#e1e4e7';
export const $Air = '#EBEDF8';
export const $Feather = '#F6F7FC';
export const $Steel = '#7f7f7f';
export const $Disabled = '#EDEEF0';
export const $DisabledCopy = '#BEBEC0';

/* Neutrals */
export const $Black = '#000000';
export const $LightBlack = '#252525';
export const $Grey = '#E7E7E7';
export const $White = '#FFFFFF';

/* Interface */
export const $Caution = '#EF476F';
export const $Caution75 = '#fdafbb';
export const $Caution25 = '#fdd8de';
export const $CautionDark = '#bf113a';

export const $Success = '#2FCFA4';
export const $Success75 = '#97e7d1';
export const $Success25 = '#cbf3e8';
export const $SuccessDark = '#1c7c62';

export const $Warning = '#FDB455';
export const $Warning75 = '#fdc67f';
export const $Warning25 = '#feecd4';
export const $WarningDark = '#e98503';

/* Accent */
export const $Go = '#2240c4';
export const $GoDark = '#1f3ab3';
export const $Action25 = '#eceffd';

export const Colors = {
  Midnight: $Midnight,
  BitPay: $BitPay,
  Action: $Action,

  SlateDark: $SlateDark,
  Slate: $Slate,
  Slate10: $Slate10,
  Slate30: $Slate30,
  Air: $Air,
  Feather: $Feather,
  Steel: $Steel,
  Disabled: $Disabled,
  DisabledCopy: $DisabledCopy,

  Black: $Black,
  LightBlack: $LightBlack,
  Grey: $Grey,
  White: $White,

  Caution: $Caution,
  Caution75: $Caution75,
  Caution25: $Caution25,
  CautionDark: $CautionDark,
  Success: $Success,
  Success75: $Success75,
  Success25: $Success25,
  SuccessDark: $SuccessDark,
  Warning: $Warning,
  Warning75: $Warning75,
  Warning25: $Warning25,
  WarningDark: $WarningDark,

  Go: $Go,
  GoDark: $GoDark,
  Action25: $Action25
};

/** ------------- SPACING -------------- */
export const $Space0 = '0px';
export const $Space1 = '4px';
export const $Space2 = '8px';
export const $Space3 = '16px';
export const $Space4 = '24px';
export const $Space5 = '36px';
export const $Space6 = '42px';
export const $Space7 = '64px';
export const $Space8 = '128px';
export const $Space9 = '256px';
export const $Space10 = '512px';

export const Spacing = {
  Space0: $Space0,
  Space1: $Space1,
  Space2: $Space2,
  Space3: $Space3,
  Space4: $Space4,
  Space5: $Space5,
  Space6: $Space6,
  Space7: $Space7,
  Space8: $Space8,
  Space9: $Space9,
  Space10: $Space10,
};
